import { FinancialAccountType } from "@common/types/financialAccount";
import { ViewType } from "@common/types/views/views";
import { reconciliationCloseTemplateViewConfigSchema } from "@common/schemas/close-template-task-view-config.schema";

export interface CreateReconciliationViewConfigParams {
    financialAccountTypes?: FinancialAccountType[];
    financialAccountIds?: number[];
}

export function createReconciliationViewConfig({
    financialAccountTypes = [],
    financialAccountIds = [],
}: CreateReconciliationViewConfigParams = {}) {
    const viewConfig =
        financialAccountIds.length > 0
            ? {
                  type: ViewType.RECONCILIATION,
                  columns: [],
                  filters: { accountIds: financialAccountIds },
              }
            : {
                  type: ViewType.RECONCILIATION,
                  columns: [],
                  filters: { financialAccountTypes },
              };
    return reconciliationCloseTemplateViewConfigSchema.parse(viewConfig);
}
